<template>
  <div :class="[classes]" :style="[styles]"
  >
    <div class="v-toolbar-content">
      <slot/>
    </div>
  </div>
</template>

<script>

import VMeasurable from "../../mixins/measurable";

export default {
  name: 'VToolbar',
  mixins: [VMeasurable],
  props: {
    absolute: Boolean,
    bottom: Boolean,
    collapse: Boolean,
    dense: Boolean,
    extended: Boolean,
    extensionHeight: {
      default: 48,
      type: [Number, String],
    },
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    short: Boolean,
    src: {
      type: [String, Object],
      default: '',
    },
    tag: {
      type: String,
      default: 'header',
    },
  },
  data() {
    return {
      isExtended: false,
    };
  },
  computed: {
    computedHeight() {
      const height = this.computedContentHeight

      if (!this.isExtended) return height

      const extensionHeight = parseInt(this.extensionHeight)

      return this.isCollapsed
        ? height
        : height + (!isNaN(extensionHeight) ? extensionHeight : 0)
    },
    computedContentHeight() {
      if (this.height) return parseInt(this.height)
      if (this.isProminent && this.dense) return 96
      if (this.isProminent && this.short) return 112
      if (this.isProminent) return 128
      if (this.dense) return 48
      if (this.short) return 56
      return 64
    },
    classes() {
      return {
        'v-sheet': true,
        'v-sheet--outlined': this.outlined,
        'v-sheet--shaped': this.shaped,
        'v-toolbar': true,
        'v-toolbar--absolute': this.absolute,
        'v-toolbar--bottom': this.bottom,
        'v-toolbar--collapse': this.collapse,
        'v-toolbar--collapsed': this.isCollapsed,
        'v-toolbar--dense': this.dense,
        'v-toolbar--extended': this.isExtended,
        'v-toolbar--flat': this.flat,
        'v-toolbar--floating': this.floating,
        'v-toolbar--prominent': this.isProminent,
      }
    },
    isCollapsed() {
      return this.collapse
    },
    isProminent() {
      return this.prominent
    },
    styles() {
      return {
        ...this.measurableStyles,
        height: this.convertToUnit(this.computedHeight),
      }
    },
  },
  methods: {
    convertToUnit (str, unit = 'px') {
      if (str == null || str === '') {
        return undefined
      } else if (isNaN(str)) {
        return String(str)
      } else {
        return `${Number(str)}${unit}`
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "VToolbar";
</style>
